(function(){
  function fireTracking(el){
    var name=el.getAttribute('data-mz-track-name');
    var ga=el.getAttribute('data-mz-ga-event');
    var fb=el.getAttribute('data-mz-fb-event');
    if(name && window.dataLayer){ window.dataLayer.push({event:name,mz_element:el.getAttribute('data-mz-track-id')||''}); }
    if(ga && window.gtag){ window.gtag('event',ga,{event_category:'MYZOO PageBuilder',event_label:el.getAttribute('data-mz-track-id')||''}); }
    if(fb && window.fbq){ window.fbq('trackCustom',fb,{element_id:el.getAttribute('data-mz-track-id')||''}); }
  }
  function initTracking(scope){
    scope.querySelectorAll('[data-mz-trackable]').forEach(function(el){
      if(el.__mzTrackInit)return; el.__mzTrackInit=true;
      el.addEventListener('click',function(){fireTracking(el)});
    });
  }
  function initTabs(scope){
    scope.querySelectorAll('[data-mz-tabs]').forEach(function(tabs){
      if(tabs.__mzTabsInit)return; tabs.__mzTabsInit=true;
      var mode=tabs.getAttribute('data-mz-tabs-mode')||'switch';
      var btns=tabs.querySelectorAll('[data-mz-tab-btn]');
      var panels=tabs.querySelectorAll('[data-mz-tab-panel]');
      if(mode==='anchor'){
        tabs.querySelectorAll('[data-mz-tab-anchor]').forEach(function(a){
          a.addEventListener('click',function(e){
            tabs.querySelectorAll('[data-mz-tab-anchor]').forEach(function(x){x.classList.toggle('is-active',x===a);});
            var href=a.getAttribute('href')||'';
            if(href.charAt(0)==='#' && href.length>1){
              var target=document.getElementById(href.slice(1));
              if(target){e.preventDefault();target.scrollIntoView({behavior:'smooth',block:'start'});}
            }
          });
        });
        return;
      }
      btns.forEach(function(btn){btn.addEventListener('click',function(){
        var id=btn.getAttribute('data-mz-tab-btn');
        btns.forEach(function(b){b.classList.toggle('is-active',b===btn)});
        panels.forEach(function(p){p.classList.toggle('is-active',p.getAttribute('data-mz-tab-panel')===id)});
      })});
    });
  }
  function initSliders(scope){
    scope.querySelectorAll('[data-mz-slider]').forEach(function(slider){
      if(slider.__mzSliderInit)return; slider.__mzSliderInit=true;
      var slides=[].slice.call(slider.querySelectorAll('.mz-slide'));
      var prev=slider.querySelector('[data-mz-prev]');
      var next=slider.querySelector('[data-mz-next]');
      var current=slider.querySelector('[data-mz-current]');
      var total=slider.querySelector('[data-mz-total]');
      var dotsWrap=slider.querySelector('[data-mz-dots]');
      var index=0;
      var dots=[];
      var productCarousel=!!slider.closest('.mz-product-grid--carousel');
      var track=slider.querySelector('.mz-slider-track');
      function readIntAttr(name, fallback){
        var v=parseInt(slider.getAttribute(name)||fallback,10);
        return isNaN(v)?fallback:v;
      }
      function getVisible(){
        var page=slider.closest('.myzoo-pagebuilder');
        var editorWidth=page ? parseInt(page.getAttribute('data-mz-editor-canvas-width')||'0',10) : 0;
        if(editorWidth<=0 && page && window.Shopify && window.Shopify.designMode && page.classList.contains('mz-editor-desktop-canvas')){
          var editorMax=parseFloat(window.getComputedStyle(page).getPropertyValue('--mz-max'))||1200;
          var editorPad=parseFloat(window.getComputedStyle(page).getPropertyValue('--mz-pad-x'))||20;
          editorWidth=Math.max(1200,Math.min(1440,editorMax+(editorPad*2)));
        }
        var viewportWidth=editorWidth>0 ? editorWidth : window.innerWidth;
        var v=readIntAttr('data-visible-desktop',1);
        if(viewportWidth<750){v=readIntAttr('data-visible-mobile',v);}
        else if(viewportWidth<990){v=readIntAttr('data-visible-tablet',v);}
        v=Math.max(1,Math.min(v,slides.length||1));
        if(!productCarousel){ slider.style.setProperty('--mz-slider-cols',v); }
        return v;
      }
      function maxIndex(){return Math.max(0,slides.length-getVisible());}
      function buildDots(){
        if(total)total.textContent=slides.length;
        if(!dotsWrap)return;
        var count=maxIndex()+1;
        dotsWrap.innerHTML='';
        for(var n=0;n<count;n++){
          var dot=document.createElement('button');
          dot.type='button';
          dot.className='mz-slider-dot';
          dot.setAttribute('aria-label','Go to slide '+(n+1));
          (function(i){dot.addEventListener('click',function(){show(i);});})(n);
          dotsWrap.appendChild(dot);
        }
        dots=[].slice.call(dotsWrap.querySelectorAll('.mz-slider-dot'));
        dotsWrap.style.display=count<=1?'none':'';
      }
      function show(i){
        if(!slides.length)return;
        var visible=getVisible();
        var max=maxIndex();
        if(i<0)i=max;
        if(i>max)i=0;
        index=i;
        if(productCarousel && track){
          slides.forEach(function(s){s.classList.add('is-active');});
          var gap=parseFloat(window.getComputedStyle(track).columnGap||window.getComputedStyle(track).gap||0)||0;
          var step=(slides[0]?slides[0].getBoundingClientRect().width:0)+gap;
          track.scrollTo({left:step*index,behavior:'smooth'});
        } else {
          slides.forEach(function(s,n){s.classList.toggle('is-active',n>=index && n<index+visible);});
        }
        dots.forEach(function(d,n){d.classList.toggle('is-active',n===index);d.setAttribute('aria-current',n===index?'true':'false');});
        if(current)current.textContent=index+1;
        var hideControls=slides.length<=visible;
        if(prev)prev.style.display=hideControls?'none':'';
        if(next)next.style.display=hideControls?'none':'';
      }
      if(prev)prev.addEventListener('click',function(){show(index-1);});
      if(next)next.addEventListener('click',function(){show(index+1);});
      buildDots();
      show(0);
      var timer=null;
      window.addEventListener('resize',function(){clearTimeout(timer);timer=setTimeout(function(){buildDots();show(Math.min(index,maxIndex()));},120);});
    });
  }

  function initPopups(scope){
    scope.querySelectorAll('[data-mz-popup-trigger]').forEach(function(btn){
      if(btn.__mzPopupInit)return; btn.__mzPopupInit=true;
      btn.addEventListener('click',function(e){
        e.preventDefault();
        var id=btn.getAttribute('data-mz-popup-trigger');
        var modal=document.getElementById(id);
        if(modal){modal.classList.add('is-open');modal.setAttribute('aria-hidden','false');}
      });
    });
    scope.querySelectorAll('[data-mz-popup-close]').forEach(function(btn){
      if(btn.__mzCloseInit)return; btn.__mzCloseInit=true;
      btn.addEventListener('click',function(){var modal=btn.closest('.mz-popup-modal'); if(modal){modal.classList.remove('is-open');modal.setAttribute('aria-hidden','true');}});
    });
    scope.querySelectorAll('.mz-popup-modal').forEach(function(modal){
      if(modal.__mzOverlayInit)return; modal.__mzOverlayInit=true;
      modal.addEventListener('click',function(e){if(e.target===modal){modal.classList.remove('is-open');modal.setAttribute('aria-hidden','true');}});
      var auto=modal.getAttribute('data-mz-auto-open');
      var delay=parseInt(modal.getAttribute('data-mz-delay')||'0',10);
      if(auto==='true'&&!modal.__mzAutoDone){modal.__mzAutoDone=true;setTimeout(function(){modal.classList.add('is-open');modal.setAttribute('aria-hidden','false');},delay*1000);}
    });
    document.addEventListener('keydown',function(e){if(e.key==='Escape'){document.querySelectorAll('.mz-popup-modal.is-open').forEach(function(m){m.classList.remove('is-open');m.setAttribute('aria-hidden','true');});}});
  }

  function initCaseShowcase(scope){
    scope.querySelectorAll('[data-mz-case-showcase]').forEach(function(showcase){
      if(showcase.__mzCaseInit)return; showcase.__mzCaseInit=true;
      var tabs=[].slice.call(showcase.querySelectorAll('[data-mz-case-tab]'));
      var panels=[].slice.call(showcase.querySelectorAll('[data-mz-case-panel]'));
      function refreshMore(panel){
        var hidden=panel.querySelectorAll('[data-mz-case-card].is-hidden').length;
        var btn=panel.querySelector('[data-mz-case-load-more]');
        if(btn)btn.classList.toggle('is-hidden',hidden===0);
      }
      tabs.forEach(function(tab){
        tab.addEventListener('click',function(e){
          var targetId=(tab.getAttribute('href')||'').replace('#','');
          var target=targetId?document.getElementById(targetId):null;
          tabs.forEach(function(t){t.classList.toggle('is-active',t===tab)});
          if(target){
            e.preventDefault();
            target.scrollIntoView({behavior:'smooth',block:'start'});
          }
        });
      });
      panels.forEach(function(panel){
        var btn=panel.querySelector('[data-mz-case-load-more]');
        if(btn){
          btn.addEventListener('click',function(){
            panel.querySelectorAll('[data-mz-case-card].is-hidden').forEach(function(card){card.classList.remove('is-hidden');});
            refreshMore(panel);
          });
        }
        refreshMore(panel);
      });
      if('IntersectionObserver' in window){
        var observer=new IntersectionObserver(function(entries){
          entries.forEach(function(entry){
            if(entry.isIntersecting){
              var key=entry.target.getAttribute('data-mz-case-panel');
              tabs.forEach(function(t){t.classList.toggle('is-active',t.getAttribute('data-mz-case-tab')===key);});
            }
          });
        },{rootMargin:'-35% 0px -55% 0px',threshold:0.01});
        panels.forEach(function(panel){observer.observe(panel);});
      }
    });
  }

  function initAnimate(scope){
    var els=scope.querySelectorAll('.mz-animate');
    if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('is-visible')});return;}
    var io=new IntersectionObserver(function(entries){entries.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-visible');io.unobserve(e.target)}})},{threshold:.12});
    els.forEach(function(e){io.observe(e)});
  }
  function init(scope){scope=scope||document;initTracking(scope);initTabs(scope);initSliders(scope);initPopups(scope);initCaseShowcase(scope);initAnimate(scope)}
  document.addEventListener('DOMContentLoaded',function(){init(document)});
  document.addEventListener('shopify:section:load',function(e){init(e.target)});
})();


(function(){
  function initIndependentCase(scope){
    scope = scope || document;
    scope.querySelectorAll('[data-mz-case-grid]').forEach(function(grid){
      if(grid.__mzCaseGridInit)return; grid.__mzCaseGridInit=true;
      var btn=grid.querySelector('[data-mz-case-load-more]');
      function refresh(){if(btn){btn.classList.toggle('is-hidden',grid.querySelectorAll('[data-mz-case-card].is-hidden').length===0);}}
      if(btn){btn.addEventListener('click',function(){grid.querySelectorAll('[data-mz-case-card].is-hidden').forEach(function(card){card.classList.remove('is-hidden');});refresh();});}
      refresh();
    });
    scope.querySelectorAll('.mz-anchor-nav a[href^="#"]').forEach(function(a){
      if(a.__mzAnchorInit)return; a.__mzAnchorInit=true;
      a.addEventListener('click',function(e){
        var id=(a.getAttribute('href')||'').slice(1); var target=id?document.getElementById(id):null;
        if(target){e.preventDefault();target.scrollIntoView({behavior:'smooth',block:'start'});}
      });
    });
  }
  document.addEventListener('DOMContentLoaded',function(){initIndependentCase(document);});
  document.addEventListener('shopify:section:load',function(e){initIndependentCase(e.target);});
})();


(function(){
  function pad(n){return String(Math.max(0,n)).padStart(2,'0');}
  function initCountdown(scope){
    scope = scope || document;
    scope.querySelectorAll('[data-mz-countdown]').forEach(function(el){
      if(el.__mzCountdownInit)return; el.__mzCountdownInit=true;
      var targetRaw = el.getAttribute('data-target') || '';
      var shopOffset = el.getAttribute('data-shop-offset') || '';
      function normalizeOffset(offset){
        if(!offset)return '';
        if(/^[-+]\d{4}$/.test(offset)){return offset.slice(0,3)+':'+offset.slice(3);}
        if(/^[-+]\d{2}:\d{2}$/.test(offset)){return offset;}
        return '';
      }
      function normalizeTarget(raw){
        raw=(raw||'').trim();
        if(!raw)return '';
        if(/^\d{4}-\d{2}-\d{2}$/.test(raw)){raw += 'T00:00:00';}
        if(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(raw)){raw += ':00';}
        if(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/.test(raw)){raw += normalizeOffset(shopOffset);}
        return raw;
      }
      var target = targetRaw ? new Date(normalizeTarget(targetRaw)) : null;
      function render(){
        var remain = target && !isNaN(target.getTime()) ? Math.max(0,target.getTime()-Date.now()) : 0;
        var totalSeconds = Math.floor(remain/1000);
        var days = Math.floor(totalSeconds/86400);
        var hours = Math.floor((totalSeconds%86400)/3600);
        var minutes = Math.floor((totalSeconds%3600)/60);
        var seconds = totalSeconds%60;
        var d=el.querySelector('[data-mz-days]'), h=el.querySelector('[data-mz-hours]'), m=el.querySelector('[data-mz-minutes]'), s=el.querySelector('[data-mz-seconds]');
        if(d)d.textContent=pad(days); if(h)h.textContent=pad(hours); if(m)m.textContent=pad(minutes); if(s)s.textContent=pad(seconds);
      }
      render();
      setInterval(render,1000);
    });
  }
  document.addEventListener('DOMContentLoaded',function(){initCountdown(document);});
  document.addEventListener('shopify:section:load',function(e){initCountdown(e.target);});
})();


(function(){
  function panelBlocksFor(markerBlock){
    var blocks=[];
    var n=markerBlock.nextElementSibling;
    while(n){
      if(n.classList && n.classList.contains('mz-tab-panel-marker-block')) break;
      if(n.classList && (n.classList.contains('mz-block') || n.classList.contains('mz-layout-row'))) blocks.push(n);
      n=n.nextElementSibling;
    }
    return blocks;
  }
  function collectGroups(root){
    var groups={};
    root.querySelectorAll('.mz-tab-panel-marker').forEach(function(marker){
      var group=marker.getAttribute('data-mz-tab-group')||'';
      var key=marker.getAttribute('data-mz-tab-key')||'';
      var markerBlock=marker.closest('.mz-block');
      if(!group||!key||!markerBlock) return;
      if(!groups[group]) groups[group]={};
      if(!groups[group][key]) groups[group][key]=[];
      groups[group][key]=groups[group][key].concat(panelBlocksFor(markerBlock));
    });
    return groups;
  }
  function showExternalTab(root, group, key){
    var groups=collectGroups(root);
    var g=groups[group]||{};
    Object.keys(g).forEach(function(k){
      g[k].forEach(function(block){block.classList.toggle('mz-external-tab-hidden', k!==key);});
    });
  }
  function initExternalTabs(scope){
    scope=scope||document;
    scope.querySelectorAll('[data-mz-tabs][data-mz-tabs-mode="external_switch"]').forEach(function(tabs){
      if(tabs.__mzExternalTabsInit) return;
      tabs.__mzExternalTabsInit=true;
      var page=tabs.closest('.myzoo-pagebuilder')||document;
      var group=tabs.getAttribute('data-mz-external-group')||'';
      var btns=[].slice.call(tabs.querySelectorAll('[data-mz-external-tab-btn]'));
      btns.forEach(function(btn){
        btn.addEventListener('click',function(){
          var key=btn.getAttribute('data-mz-external-tab-btn')||'1';
          btns.forEach(function(b){b.classList.toggle('is-active',b===btn);});
          showExternalTab(page,group,key);
        });
      });
      var first=tabs.querySelector('[data-mz-external-tab-btn].is-active')||tabs.querySelector('[data-mz-external-tab-btn]');
      if(first) showExternalTab(page,group,first.getAttribute('data-mz-external-tab-btn')||'1');
    });
  }
  document.addEventListener('DOMContentLoaded',function(){initExternalTabs(document);});
  document.addEventListener('shopify:section:load',function(e){initExternalTabs(e.target);});
})();

(function(){
  function isMarker(el, cls){ return el && el.classList && el.classList.contains(cls); }
  function isHardStop(el){
    return isMarker(el,'mz-layout-marker-block') || isMarker(el,'mz-layout-end-marker-block') || isMarker(el,'mz-tab-panel-marker-block');
  }
  var layoutBoxProps=[
    '--mz-mt','--mz-mr','--mz-mb','--mz-ml','--mz-pt','--mz-pr','--mz-pb','--mz-pl',
    '--mz-tablet-mt','--mz-tablet-mr','--mz-tablet-mb','--mz-tablet-ml','--mz-tablet-pt','--mz-tablet-pr','--mz-tablet-pb','--mz-tablet-pl',
    '--mz-mobile-mt','--mz-mobile-mr','--mz-mobile-mb','--mz-mobile-ml','--mz-mobile-pt','--mz-mobile-pr','--mz-mobile-pb','--mz-mobile-pl',
    '--mz-block-bg','--mz-block-text','--mz-opacity','--mz-radius','--mz-border-style','--mz-border-width','--mz-border-color','--mz-shadow'
  ];
  function copyLayoutBoxVars(source,target){
    layoutBoxProps.forEach(function(prop){
      var val=source.style.getPropertyValue(prop);
      if(val) target.style.setProperty(prop,val);
    });
  }
  function copyColumnBoxVars(source,target){
    layoutBoxProps.forEach(function(prop){
      var val=source.style.getPropertyValue(prop);
      if(!val) return;
      target.style.setProperty(prop.replace('--mz-','--mz-col-'),val);
    });
  }
  function initLayoutRows(scope){
    scope=scope||document;
    scope.querySelectorAll('.myzoo-pagebuilder .mz-grid').forEach(function(grid){
      var markers=[].slice.call(grid.querySelectorAll(':scope > .mz-layout-marker-block'));
      markers.forEach(function(markerBlock){
        if(markerBlock.__mzLayoutBuilt) return;
        var marker=markerBlock.querySelector('[data-mz-layout-start]');
        if(!marker) return;
        var cols=parseInt(marker.getAttribute('data-mz-layout-cols')||'2',10)||2;
        var mobileCols=parseInt(marker.getAttribute('data-mz-layout-mobile-cols')||'1',10)||1;
        var gap=parseInt(marker.getAttribute('data-mz-layout-gap')||'24',10)||24;
        var ratio=marker.getAttribute('data-mz-layout-ratio')||'equal';
        var sync=(marker.getAttribute('data-mz-layout-sync')==='true');
        var row=document.createElement('div');
        row.className='mz-layout-row';
        row.style.setProperty('--mz-layout-cols', String(cols));
        row.style.setProperty('--mz-layout-mobile-cols', String(mobileCols));
        row.style.setProperty('--mz-layout-gap', gap+'px');
        /* Copy Row marker spacing/design variables to the generated row.
           The marker itself is hidden, so its settings must be transferred. */
        copyLayoutBoxVars(markerBlock,row);
        row.setAttribute('data-mz-ratio', ratio);
        row.setAttribute('data-mz-sync', sync ? 'true' : 'false');
        var colEls=[];
        for(var i=1;i<=cols;i++){
          var col=document.createElement('div');
          col.className='mz-layout-col';
          col.setAttribute('data-mz-layout-col', String(i));
          colEls.push(col); row.appendChild(col);
        }
        grid.insertBefore(row, markerBlock.nextSibling);

        var currentCol=1;
        var autoCol=1;
        var hasColumnMarkers=false;
        var scan=row.nextElementSibling;
        while(scan){
          if(isHardStop(scan)) break;
          if(isMarker(scan,'mz-layout-column-marker-block')){ hasColumnMarkers=true; break; }
          scan=scan.nextElementSibling;
        }

        var n=row.nextElementSibling;
        while(n){
          var next=n.nextElementSibling;
          if(isHardStop(n)) break;
          if(isMarker(n,'mz-layout-column-marker-block')){
            var cm=n.querySelector('[data-mz-layout-column]');
            currentCol=parseInt(cm && cm.getAttribute('data-mz-layout-column') || '1',10)||1;
            var columnTarget=colEls[Math.max(0,Math.min(cols-1,currentCol-1))] || colEls[0];
            /* Column markers are hidden separators. Transfer their margin, padding,
               background and border settings to the real generated column. */
            copyColumnBoxVars(n,columnTarget);
          }else if(isMarker(n,'mz-block')){
            var useCol=hasColumnMarkers ? currentCol : autoCol;
            var target=colEls[Math.max(0,Math.min(cols-1,useCol-1))] || colEls[0];
            target.appendChild(n);
            if(!hasColumnMarkers){ autoCol = autoCol >= cols ? 1 : autoCol + 1; }
          }
          n=next;
        }
        markerBlock.__mzLayoutBuilt=true;
        if(sync){ initSyncRow(row); }
      });
    });
  }
  function initSyncRow(row){
    var cols=[].slice.call(row.querySelectorAll(':scope > .mz-layout-col'));
    function blockType(block){ return block.getAttribute('data-mz-block-type') || ''; }
    function wrapGroups(col,groups){
      var items=[];
      groups.forEach(function(group,page){
        if(!group.length) return;
        var item=document.createElement('div');
        item.className='mz-layout-sync-item';
        item.setAttribute('data-mz-sync-item-page',String(page));
        col.insertBefore(item,group[0]);
        group.forEach(function(block){ item.appendChild(block); });
        items.push(item);
      });
      col.__mzSyncGrouped=true;
      return items;
    }
    function buildSyncItems(col){
      if(col.__mzSyncGrouped) return [].slice.call(col.querySelectorAll(':scope > .mz-layout-sync-item'));
      var blocks=[].slice.call(col.querySelectorAll(':scope > .mz-block'));
      if(!blocks.length){ col.__mzSyncGrouped=true; return []; }

      /* V70: A column marker chooses the column; it does not define a slide page.
         For synchronized text columns, each heading starts a new page and every
         following block stays with that heading until the next heading. This keeps
         Heading + multiple Rich text/Button blocks together as one page.
         Media-only / heading-less columns keep the legacy one-block-per-page rule,
         so Image 1, Image 2, ... still synchronize as separate pages. */
      var hasHeading=blocks.some(function(block){ return blockType(block)==='heading'; });
      var groups=[];
      if(hasHeading){
        var current=[];
        blocks.forEach(function(block){
          if(blockType(block)==='heading' && current.length){
            groups.push(current);
            current=[];
          }
          current.push(block);
        });
        if(current.length) groups.push(current);
      }else{
        blocks.forEach(function(block){ groups.push([block]); });
      }
      return wrapGroups(col,groups);
    }
    var colItems=cols.map(buildSyncItems);
    var max=0;
    colItems.forEach(function(items){ max=Math.max(max,items.length); });

    /* One synchronized page stays visible but has no carousel UI. */
    if(max<=1){
      colItems.forEach(function(items){
        items.forEach(function(item,ii){ item.classList.toggle('is-active',ii===0); });
      });
      return;
    }

    var index=0;
    var controls=document.createElement('div');
    controls.className='mz-layout-sync-controls';
    controls.innerHTML='<button class="mz-layout-sync-btn" type="button" data-mz-layout-prev>‹</button><button class="mz-layout-sync-btn" type="button" data-mz-layout-next>›</button>';
    var dots=document.createElement('div');
    dots.className='mz-layout-sync-dots';
    for(var i=0;i<max;i++){
      var b=document.createElement('button');
      b.type='button'; b.className='mz-layout-sync-dot'; b.setAttribute('data-mz-layout-dot',String(i));
      dots.appendChild(b);
    }
    row.appendChild(controls); row.appendChild(dots);
    function show(i){
      index=(i+max)%max;
      colItems.forEach(function(items){
        items.forEach(function(item,ii){ item.classList.toggle('is-active',ii===index); });
      });
      [].slice.call(dots.querySelectorAll('[data-mz-layout-dot]')).forEach(function(d,di){ d.classList.toggle('is-active',di===index); });
    }
    controls.querySelector('[data-mz-layout-prev]').addEventListener('click',function(){show(index-1);});
    controls.querySelector('[data-mz-layout-next]').addEventListener('click',function(){show(index+1);});
    dots.addEventListener('click',function(e){ var d=e.target.closest('[data-mz-layout-dot]'); if(d) show(parseInt(d.getAttribute('data-mz-layout-dot'),10)||0); });
    show(0);
  }
  document.addEventListener('DOMContentLoaded',function(){initLayoutRows(document);});
  document.addEventListener('shopify:section:load',function(e){initLayoutRows(e.target);});
  document.addEventListener('shopify:block:select',function(e){initLayoutRows(e.target && e.target.closest ? (e.target.closest('.myzoo-pagebuilder')||document) : document);});
})();

(function(){
  function refreshExternalTabs(scope){
    scope=scope||document;
    scope.querySelectorAll('[data-mz-tabs][data-mz-tabs-mode="external_switch"]').forEach(function(tabs){
      var active=tabs.querySelector('[data-mz-external-tab-btn].is-active')||tabs.querySelector('[data-mz-external-tab-btn]');
      if(active) active.click();
    });
  }
  document.addEventListener('DOMContentLoaded',function(){setTimeout(function(){refreshExternalTabs(document);},0);});
  document.addEventListener('shopify:section:load',function(e){setTimeout(function(){refreshExternalTabs(e.target);},0);});
})();

/* v44: Theme editor scroll stability
   Shopify theme editor may re-render the preview while changing settings; keep the preview
   near the same scroll position instead of jumping downward after each adjustment. */
(function(){
  if(!window.Shopify || !window.Shopify.designMode) return;
  var KEY='mz_pagebuilder_preview_scroll_y';
  var lastY=0;
  var save=function(){
    lastY=window.scrollY || window.pageYOffset || 0;
    try{ sessionStorage.setItem(KEY,String(lastY)); }catch(e){}
  };
  var restore=function(){
    var y=lastY;
    try{
      var stored=sessionStorage.getItem(KEY);
      if(stored!==null) y=parseInt(stored,10)||0;
    }catch(e){}
    if(y<0) y=0;
    window.scrollTo(0,y);
  };
  ['scroll','shopify:section:select','shopify:block:select'].forEach(function(evt){
    window.addEventListener(evt,save,{passive:true});
  });
  document.addEventListener('shopify:section:unload',save);
  document.addEventListener('shopify:section:load',function(){
    setTimeout(restore,0);
    setTimeout(restore,120);
    setTimeout(restore,350);
  });
})();


/* V64: Keep the PageBuilder desktop canvas centered in Shopify's editor.
   The old code measured the whole preview iframe. Some themes place the section
   inside a narrower wrapper, so the scaled canvas was clipped on the right and
   looked left-aligned. Measure the section parent's actual content width instead. */
(function(){
  if(!window.Shopify || !window.Shopify.designMode) return;

  var MIN_EDITOR_WIDTH=600;
  var MIN_DESKTOP_CANVAS=1200;
  var MAX_DESKTOP_CANVAS=1440;
  var resizeTimer=null;
  var observedParents=[];
  var parentObserver=('ResizeObserver' in window)?new ResizeObserver(function(){scheduleRefresh();}):null;

  function numberVar(el,name,fallback){
    var value=parseFloat(window.getComputedStyle(el).getPropertyValue(name));
    return isNaN(value)?fallback:value;
  }

  function getCanvasWidth(page){
    var contentMax=numberVar(page,'--mz-max',1200);
    var sidePad=numberVar(page,'--mz-pad-x',20);
    return Math.max(MIN_DESKTOP_CANVAS,Math.min(MAX_DESKTOP_CANVAS,contentMax+(sidePad*2)));
  }

  function getAvailableWidth(page){
    var parent=page.parentElement;
    if(parent){
      var style=window.getComputedStyle(parent);
      var left=parseFloat(style.paddingLeft)||0;
      var right=parseFloat(style.paddingRight)||0;
      var parentWidth=parent.clientWidth-left-right;
      if(parentWidth>0) return parentWidth;
    }
    return Math.max(0,document.documentElement.clientWidth||window.innerWidth||0);
  }

  function observeParent(page){
    if(!parentObserver || !page.parentElement) return;
    if(observedParents.indexOf(page.parentElement)!==-1) return;
    observedParents.push(page.parentElement);
    parentObserver.observe(page.parentElement);
  }

  function clearCanvas(page){
    page.classList.remove('mz-editor-fixed-canvas');
    page.style.removeProperty('--mz-editor-canvas-width');
    page.style.removeProperty('--mz-editor-canvas-scale');
    page.removeAttribute('data-mz-editor-canvas-width');
    if(page.parentElement) page.parentElement.classList.remove('mz-editor-fixed-canvas-parent');
  }

  function applyCanvas(page){
    var available=getAvailableWidth(page);
    if(available<MIN_EDITOR_WIDTH){
      clearCanvas(page);
      return;
    }

    var canvasWidth=getCanvasWidth(page);
    var scale=Math.min(1,available/canvasWidth);
    page.classList.add('mz-editor-fixed-canvas');
    page.style.setProperty('--mz-editor-canvas-width',canvasWidth+'px');
    page.style.setProperty('--mz-editor-canvas-scale',String(Math.max(0.1,scale)));
    page.setAttribute('data-mz-editor-canvas-width',String(canvasWidth));
    if(page.parentElement) page.parentElement.classList.add('mz-editor-fixed-canvas-parent');
    observeParent(page);
  }

  function refresh(scope){
    scope=scope||document;
    var pages=[];
    if(scope.matches && scope.matches('.myzoo-pagebuilder')) pages.push(scope);
    if(scope.querySelectorAll){
      pages=pages.concat([].slice.call(scope.querySelectorAll('.myzoo-pagebuilder')));
    }
    pages.filter(function(page,index,list){return list.indexOf(page)===index;}).forEach(applyCanvas);
  }

  function scheduleRefresh(){
    window.clearTimeout(resizeTimer);
    resizeTimer=window.setTimeout(function(){refresh(document);},80);
  }

  document.addEventListener('DOMContentLoaded',function(){refresh(document);});
  document.addEventListener('shopify:section:load',function(event){refresh(event.target);});
  document.addEventListener('shopify:section:select',function(event){refresh(event.target);});
  document.addEventListener('shopify:block:select',function(event){
    refresh(event.target && event.target.closest ? (event.target.closest('.myzoo-pagebuilder')||document) : document);
  });
  window.addEventListener('resize',scheduleRefresh,{passive:true});
})();
